/**
 * 将日期转换为评论区的日期显示格式
 * @param { Number } num 数字
 * @return { String } 格式化后的字符串
 */
export default num => {
  const d = new Date(num)

  return `${d.getMonth() + 1}-${d.getDate()} ${d.getHours() >= 10 ? d.getHours() : '0' + d.getHours()}:${d.getMinutes() >= 10 ? d.getMinutes() : '0' + d.getMinutes()}`
}
